import { makeStyles } from '@material-ui/core';
import './../../commons/Constants'
import { OwnColors } from './../../commons/Constants';

const adminTrackingStyles = makeStyles(theme => ({
    mainContainer: {
        marginTop: 54,
        marginBottom: '70px',
        [theme.breakpoints.up('sm')]: {
            marginTop: 64,
        },
    },
    container: {
        display: "flex",
        flexDirection: "row",
        height: "100vh",
        //marginTop: "48px"
    },
    circleProgress: {
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        position: 'fixed',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        zIndex: 10
    },
    actionButtons: {
        cursor: 'pointer'
    },
    activateButton: {
        backgroundColor: OwnColors.mobelBlue,
        color: 'white',
        marginRight: 10
    }
}));

export default adminTrackingStyles;